import { Lights, P, Particles, Rng, fit, flare, sparkle, type FxMeta } from "pixelfx";

/**
 * Искра удара под наш масштаб (боец 190 px арта, пиксель 2×2 точки): короткая вспышка-крест, лучи, веер искр по
 * ходу удара и свет, гаснущий за четверть секунды. Белое — только ядро в несколько пикселей, бойцы видны сквозь
 * эффект. Собрана на инструментах pixelfx: flare, sparkle, Particles, Lights.
 */
export const meta: FxMeta & { options: Record<string, unknown> } = {
  name: "HD spark",
  duration: 0.7,
  loop: false,
  fps: 60,
  size: [240, 160],
  origin: [120, 80],
  options: {
    seed: 1,
    strength: 1,
    flip: false,
    palette: ["#4a1712", "#c9281f", "#f2561d", "#ff8a2a", "#ffe26b", "#fff3a6", "#ffffff"],
  },
};

interface SparkOptions {
  seed: number;
  strength: number;
  flip: boolean;
  palette: readonly string[];
}

export function create(options: SparkOptions): { update(dt: number): void; draw(painter: unknown): void } {
  const random = new Rng(options.seed);
  const ramp = fit(options.palette, 7);
  const power = 0.7 + options.strength * 0.45;
  const direction = options.flip ? -1 : 1;
  const particles = new Particles({ rng: random, sparks: ramp.slice(3) });
  const lights = new Lights();
  lights.add(0, 0, 70 * power, ramp[5] ?? 0xffffffff, 0.55, 0.28);
  const count = Math.round(16 + 14 * options.strength);
  for (let index = 0; index < count; index++) {
    const angle = random.range(-0.9, 0.9) + (direction > 0 ? 0 : Math.PI);
    const speed = random.range(260, 720) * power;
    particles.spawn(
      P.SPARK ?? 0,
      0,
      0,
      Math.cos(angle) * speed,
      Math.sin(angle) * speed - 80,
      random.range(0.15, 0.42),
    );
  }
  let time = 0;
  return {
    update(dt: number): void {
      time += dt;
      particles.update(dt);
      lights.update(dt);
    },
    draw(painter: unknown): void {
      if (time < 0.09) flare(painter, 0, 0, 30 * power * (1 - time / 0.12), 0.7, options.palette);
      if (time < 0.16) sparkle(painter, 0, 0, 22 * power * (1 - time / 0.16), ramp[6] ?? 0xffffffff, ramp[4], 0.6);
      particles.draw(painter);
      lights.draw(painter);
    },
  };
}
